module.exports = __webpack_public_path__ + "static/img/myserver2.5e136d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/myserver2.png
// module id = K/yS
// module chunks = 0